import  request  from '@/umi-request';
import { AxiosPromise } from 'axios';

import {
  Allowance,
  ShortAllowance,
  AllowanceLimit,
  Benefit,
  BenefitType,
  TNotOrdinaryAllowanceLimitPerPeriod,
} from '@/interfaces/allowances';
import { PaginatedResponse } from '@/interfaces/response';

export async function queryAllowancesOnce(params: any, token: any) {
  return request({
    url: 'allowances/',
    params,
    cancelToken: token,
  })  as AxiosPromise<PaginatedResponse<Allowance>>;
}

export async function queryAllowances(params: any) {
  return request({
    url: 'allowances/',
    params,
  })  as AxiosPromise<PaginatedResponse<Allowance>>;
}

export async function queryShortAllowances() {
  return request({
    url: 'allowances/short/',
    method: 'GET'
  }) as AxiosPromise<ShortAllowance[]>;
}

export async function queryAllowance(id: string | number) {
  return request({
    url: `allowances/${id}/`,
    method: 'GET'
  })  as AxiosPromise<Allowance>;
}

export async function queryAllowance_limit_period(params: any) {
  return request({
    url: `allowances/allowance_limit_period`,
    params,
  }) as AxiosPromise<PaginatedResponse<AllowanceLimit>>;
}

export async function queryCoverageAllowance_limit_period(params: any = {}) {
  return request({
    url: `allowances/limit_coverage_period`,
    params,
  }) as AxiosPromise<TNotOrdinaryAllowanceLimitPerPeriod>;
}

export async function uploadAllowance_create_limit(id: number | string, data: any = {}) {
  return request({
    url: `allowances/${id}/limits/`,
    method: 'POST',
    data
  }) as AxiosPromise<AllowanceLimit>;
}

export async function queryNextAllowanceLimit(params: any) {
  return request({
    url: 'allowances/nextAllowanceLimit/',
    params,
  }) as AxiosPromise<PaginatedResponse<AllowanceLimit>>;
}

export async function updateAllowance(id: string | number, data: any) {
  return request({
    url: `allowances/${id}/`,
    method: 'PATCH',
    data
  }) as AxiosPromise<Allowance>;
}

export async function updateAllowanceLimit(
  id: string | number,
  id_limit: string | number,
  data: any,
) {
  return request({
    url: `allowances/${id}/limits/${id_limit}/`,
    method: 'PATCH',
    data
  }) as AxiosPromise<AllowanceLimit>;
}

export async function queryAllowanceLimit(id: string | number, params: any = {}) {
  return request({
    url: `allowances/${id}/limits/`,
    params,
  }) as AxiosPromise<PaginatedResponse<AllowanceLimit>>;
}

export async function queryBenefitTypes(params: any = {}) {
  return request({
    url: 'benefit-types/',
    params
  }) as AxiosPromise<BenefitType[]>;
}

export async function queryBenefits(params: any = {}) {
  return request({
    url: 'benefits/',
    params,
  }) as AxiosPromise<PaginatedResponse<Benefit>>;
}
